/**
 * FolderBreadcrumb Component
 * Breadcrumb navigation for folder hierarchy
 */

import React from 'react';
import { FolderBreadcrumbNav } from '@/components/ccms-components/file-management';
import { Group } from '@/components/ui/layout';
import { ActionIcon } from '@/components/ui';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';
import { BreadcrumbSegment } from '../types';

interface FolderBreadcrumbProps {
  breadcrumbs: BreadcrumbSegment[];
  onNavigate: (path: string) => void;
  canGoBack?: boolean;
  canGoForward?: boolean;
  onGoBack?: () => void;
  onGoForward?: () => void;
}

export const FolderBreadcrumb: React.FC<FolderBreadcrumbProps> = ({
  breadcrumbs,
  onNavigate,
  canGoBack = false,
  canGoForward = false,
  onGoBack,
  onGoForward,
}) => {
  // Convert breadcrumbs to path string
  const currentPath = breadcrumbs.length > 0
    ? breadcrumbs[breadcrumbs.length - 1].path
    : '/';

  return (
    <Group gap="xs">
      {/* Navigation arrows */}
      {(onGoBack || onGoForward) && (
        <Group gap={4}>
          <ActionIcon
            size="sm"
            variant="subtle"
            disabled={!canGoBack}
            onClick={onGoBack}
            title="Go back"
          >
            <IconChevronLeft size={16} />
          </ActionIcon>
          <ActionIcon
            size="sm"
            variant="subtle"
            disabled={!canGoForward}
            onClick={onGoForward}
            title="Go forward"
          >
            <IconChevronRight size={16} />
          </ActionIcon>
        </Group>
      )}

      {/* Breadcrumbs using library component */}
      <FolderBreadcrumbNav
        path={currentPath}
        onNavigate={onNavigate}
        showHome
        maxItems={5}
      />
    </Group>
  );
};
